import React, { memo } from 'react';
import { Button, Icon, Typography } from '@ann/web-components';
import { WIDGET_LIBRARY_COPY } from '../../../../constants/dashboardBuilderCopy';
import { CategoryItem, Container, Header, List, Title } from './CategoryPanel.styled';

const CategoryPanel = ({ categories, selectedCategory, onSelectCategory, isOpen, onToggle }) => (
  <Container $isOpen={isOpen}>
    <Header $isOpen={isOpen}>
      <Title $isOpen={isOpen}>
        <Typography category="subtitle" size="small" weight="bold">
          {WIDGET_LIBRARY_COPY.categoriesTitle}
        </Typography>
      </Title>
      <Button
        type="tertiary"
        size="small"
        icon={isOpen ? 'dock_to_left' : 'dock_to_right'}
        title={isOpen ? WIDGET_LIBRARY_COPY.collapseSidebar : WIDGET_LIBRARY_COPY.expandSidebar}
        aria-label={isOpen ? WIDGET_LIBRARY_COPY.collapseSidebar : WIDGET_LIBRARY_COPY.expandSidebar}
        onClick={onToggle}
      />
    </Header>
    <List $isOpen={isOpen}>
      {categories.map((category) => (
        <CategoryItem
          key={category}
          role="button"
          tabIndex={0}
          $active={selectedCategory === category}
          onClick={() => onSelectCategory(category)}
          onKeyDown={(e) => e.key === 'Enter' && onSelectCategory(category)}
        >
          <span>{category}</span>
          <Icon name="chevronRight" size="small" />
        </CategoryItem>
      ))}
    </List>
  </Container>
);

export default memo(CategoryPanel);
